import { render, staticRenderFns } from "./nb-lock.vue?vue&type=template&id=39b22340&scoped=true"
import script from "./nb-lock.vue?vue&type=script&lang=js"
export * from "./nb-lock.vue?vue&type=script&lang=js"
import style0 from "./nb-lock.vue?vue&type=style&index=0&id=39b22340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b22340",
  null
  
)

export default component.exports